export const PrepareDataForLuxpayTransaction = (values: any, accountId?: number | null | undefined, code?: string, withdrawalStatus?: string, ) => {

     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

     return {
          accNumberFrom: values.accountNumber,
          accNumberTo: values.hiddenAccountNumber ? values.hiddenAccountNumber : values.accNumberTo,
          amount: Number(values.amount),
          transferType: values.transferMethod,
          recipientType: values.accountType,
          recipientDetails: {
               purpose: values.reference ? values.reference : values.purpose,
               email: values.email,
               phone: values.phoneNumber
          },
          reference: values.reference ? values.reference : values.purpose,
          templateName: values.templateName,
          type: values.type,
          currency: values.transferCurrency,
          accountId: accountId,
          invoice: values.invoice.data,
          invoiceFilename: values?.invoice?.name,
          withdrawalCode: code,
          twoFaCode: values.twoFaCode,
          userTimezone: timezone,
          clientId: values.clientId,
     }
}
